// extracted by mini-css-extract-plugin
export default {"dragging":"style-module__IndGA"};